var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { ProjetoFundiariosApi } from '../../apis/projetos-fundiarios-api';
import { outrosOpt } from '../../modules/Requerimento/Cadastro/context/RequerimentoContext';
import { DefaultAutoComplete } from '../DefaultAutoComplete';
import { HandleError } from '../../modules/utils/HandleError';
import { OUTRO_OPT } from '../../util/CommonUtils';
export var CampoQuadra = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.otherOption, otherOption = _f === void 0 ? OUTRO_OPT : _f, _g = _a.addOther, addOther = _g === void 0 ? false : _g, _h = _a.required, required = _h === void 0 ? true : _h, _j = _a.refChange, refChange = _j === void 0 ? null : _j, _k = _a.disabled, disabled = _k === void 0 ? false : _k, onShowChange = _a.onShowChange, fieldError = _a.fieldError, onChange = _a.onChange, value = _a.value;
    //region Constants
    var _l = useState(false), disabledState = _l[0], setDisabledState = _l[1];
    var _m = useState(addOther), addOtherOpt = _m[0], setAddOtherOpt = _m[1];
    var _o = useState([]), values = _o[0], setValues = _o[1];
    var _p = useState(), error = _p[0], setError = _p[1];
    //endregion
    //region Hooks
    var selectQuadraProm = useCallback(function () {
        var params = {};
        if (refChange === null || refChange === void 0 ? void 0 : refChange.id) {
            params['projetoFundId'] = refChange.id;
        }
        return ProjetoFundiariosApi.selectAllQuadras(params);
    }, [refChange === null || refChange === void 0 ? void 0 : refChange.id]);
    var show = useMemo(function () {
        var _a;
        return addOther && (((_a = value === null || value === void 0 ? void 0 : value.quadra) === null || _a === void 0 ? void 0 : _a.denominacao) === (outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao) || !!(value === null || value === void 0 ? void 0 : value.outraQuadra));
    }, [addOther, (_b = value === null || value === void 0 ? void 0 : value.quadra) === null || _b === void 0 ? void 0 : _b.denominacao, value === null || value === void 0 ? void 0 : value.outraQuadra]);
    useEffect(function () {
        if (value === null || value === void 0 ? void 0 : value.outraQuadra) {
            if (onChange)
                onChange(__assign(__assign({}, value), { quadra: outrosOpt }));
        }
    }, []);
    useEffect(function () {
    }, [values, value]);
    useEffect(function () {
        var _a;
        if (((_a = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.nome) === (OUTRO_OPT === null || OUTRO_OPT === void 0 ? void 0 : OUTRO_OPT.nome)) {
            if (onChange)
                onChange(__assign(__assign({}, value), { quadra: outrosOpt }));
            setAddOtherOpt(true);
        }
    }, [(_c = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _c === void 0 ? void 0 : _c.nome]);
    useEffect(function () {
        var _a;
        if (((_a = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.nome) === (outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao)) {
            setDisabledState(true);
            return;
        }
        setDisabledState(false);
    }, [value === null || value === void 0 ? void 0 : value.projetoFundiario]);
    useEffect(function () {
        selectQuadraProm().then(function (response) {
            if (addOther) {
                setValues(__spreadArray([OUTRO_OPT], response, true));
            }
            else {
                setValues(__spreadArray([], response, true));
            }
        }).catch(function (error) {
            setError(error);
        });
    }, [refChange, addOtherOpt]);
    useEffect(function () {
        onShowChange === null || onShowChange === void 0 ? void 0 : onShowChange(show);
        if (addOther && !!(value === null || value === void 0 ? void 0 : value.outraQuadra)) {
            if (onChange)
                onChange(__assign(__assign({}, value), { quadra: outrosOpt }));
        }
    }, [show, addOther]);
    //endregion
    //region Handles
    var handleChange = function (dadosImovel) {
        var _a;
        if (((_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.quadra) === null || _a === void 0 ? void 0 : _a.denominacao) !== (outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, dadosImovel), { outraQuadra: undefined }));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, dadosImovel));
        }
    };
    var isOutraQuadra = useMemo(function () {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.quadra) === null || _a === void 0 ? void 0 : _a.denominacao) === (outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao);
    }, [(_d = value === null || value === void 0 ? void 0 : value.quadra) === null || _d === void 0 ? void 0 : _d.denominacao]);
    var isOutroLote = useMemo(function () {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.lote) === null || _a === void 0 ? void 0 : _a.denominacao) === (outrosOpt === null || outrosOpt === void 0 ? void 0 : outrosOpt.denominacao);
    }, [(_e = value === null || value === void 0 ? void 0 : value.lote) === null || _e === void 0 ? void 0 : _e.denominacao]);
    var size = useMemo(function () {
        if (!isOutraQuadra && !isOutroLote) {
            return 6;
        }
        return isOutraQuadra ? 6 : 12;
    }, [isOutraQuadra, isOutroLote]);
    //endregion
    return (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: size }, { children: _jsx(DefaultAutoComplete, { onChange: function (_quadra) { return handleChange(__assign(__assign({}, value), { quadra: _quadra, lote: outrosOpt })); }, noOptionsText: "Nenhuma Quadra encontrada", disabled: disabled || disabledState, placeholder: "Selecione uma quadra", fieldName: 'denominacao', fieldError: fieldError, value: value === null || value === void 0 ? void 0 : value.quadra, fieldsList: values, required: required, refChange: values, label: "Quadra", name: "quadra" }) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
